import React from 'react';

interface BackgroundWrapperProps {
    children: React.ReactNode;
    hasScreens?: boolean;
}

export const BackgroundWrapper: React.FC<BackgroundWrapperProps> = ({ children, hasScreens = false }) => {
    return (
        <div 
            className="relative min-h-screen w-full bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: hasScreens
                    ? 'none'
                    : `url(${import.meta.env.BASE_URL}background.jpeg)`,
                backgroundColor: hasScreens ? '#000000' : 'transparent',
            }}
        >
            {children}
        </div>
    );
};
